/**
 * Service for executing panelist aggregation queries
 * Used to determine default branch selection based on panelist counts
 */

/**
 * Builds the filter object for aggregation query
 * @param {Object} baseFilterObject - Base filter object from buildFilterObject
 * @param {Array} branchIds - Array of branch IDs to aggregate
 * @returns {Object} - Filter object configured for aggregation
 */
export const buildAggregationFilterObject = (baseFilterObject, branchIds) => {
  const aggregationFilterObject = { ...baseFilterObject }
  delete aggregationFilterObject.branch_id
  aggregationFilterObject.aggregation_field = 'branch_ids'
  aggregationFilterObject.aggregation_values = branchIds
  return aggregationFilterObject
}

/**
 * Executes panelist aggregation query
 * @param {Object} panelistAggregation - API resource for aggregation
 * @param {Object} filterObject - Filter object for the query
 * @returns {Promise<Object>} - Promise resolving to aggregation response
 */
export const executePanelistAggregation = async (panelistAggregation, filterObject) => {
  return panelistAggregation.post(filterObject)
}

/**
 * Extracts panelist counts from aggregation response
 * @param {Object} aggregationResponse - Response from aggregation API
 * @returns {Object} - Object mapping branch_id to panelist count
 */
export const extractPanelistCounts = (aggregationResponse) => {
  return aggregationResponse?.aggregation_results?.panelist_counts || {}
}
